export function initializeParallaxFooter() {
    const isTouchDevice = ('ontouchstart' in window) || window.matchMedia("(pointer: coarse)").matches;

    if (!isTouchDevice) {
        gsap.set('.footer__container', { yPercent: -80 });
        const uncover = gsap.timeline({ paused: true });

        uncover.to('.footer__container', { yPercent: 0 });

        ScrollTrigger.create({
            trigger: '.pre-footer',
            start: 'bottom bottom',
            end: '+=75%',
            animation: uncover,
            scrub: true,
        });
    }
}